<template>
  <div style="margin-bottom: 64px">
    <app-bar @on_click_open_chat="dialog_chat=true"></app-bar>
    <drawer
        @on_change_user="open_dialog_change_user_password" />
    <!-- Ruta padre dashboard/ -->
    <router-view></router-view>

    <DialogAlarma ref="dialog_alarma" />
    <DialogChangeUserPassword ref="dialog_change_user_password" />
    <DialogTutorial v-model="dialog_tutorial" />

    <DialogChat
        v-if="dialog_chat"
        ref="dialog_chat"
        v-model="dialog_chat"
      />
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Vue from 'vue'
import store from '@/store'
import VueNativeSock from 'vue-native-websocket';

export default {
  data(){
    return {
      dialog_chat: false,
      aws_s3_bucket_url: process.env.VUE_APP_AWS_S3_BUCKET,
    }
  },

  components: {
    AppBar: () => import('@/components/core/AppBar'),
    Drawer: () => import('@/components/core/Drawer'),
    DialogAlarma: () => import('@/components/core/DialogAlarma'),
    DialogChangeUserPassword: () => import('@/components/shared/DialogChangeUserPassword'),
    DialogTutorial: () => import('@/components/core/DialogTutorial'),
    DialogChat: () => import('@/components/shared/DialogChat.vue'),

  },
  methods: {
    init_socket(){
      const token = store.getters['auth/access_token']
	    const VUE_WEBSOCKET_ENDPOINT = process.env.VUE_APP_WEBSOCKET_ENDPOINT
      const VUE_WEBSOCKET_PROTOCOL = process.env.VUE_APP_WEBSOCKET_PROTOCOL
      Vue.use(VueNativeSock, `${VUE_WEBSOCKET_PROTOCOL}://${VUE_WEBSOCKET_ENDPOINT}/socket.io/?x-token=${token}`, {
        store: store,
        format: 'json',
        reconnection: true, // (Boolean) whether to reconnect automatically (false)
        reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
        reconnectionDelay: 3000 // (Number) how long to initially wait before attempting a new (1000)
      });
    },

    set_title_and_favicon(){
      switch (window.location.hostname) {
        case 'panel.alidaria.es':
          document.title = "Ali d'Aria"
          document.getElementById('web_favicon').href = `${this.aws_s3_bucket_url}assets/icons/alidaria.png`
          break;
        case 'gestion.mikymika.com':
          document.title = "Miky Mika"
          break;
        case 'crm.nycecosmetics.es':
          document.title = "NYCE Cosmetics"
          document.getElementById('web_favicon').href = `${this.aws_s3_bucket_url}assets/icons/nycecosmetics.png`
          break;
      }
    },

    /**
     * Abre el dialog de la alarma que se recibe del socket
     * @param alarma_id
     * @returns {Promise<void>}
     */
    async open_dialog_alarma(alarma_id){
      try{
        const alarma = await this.$store.dispatch('alarma/get_alarma', alarma_id)
        this.$refs.dialog_alarma.open_alarma(alarma)
        this.show_browser_notification(alarma.detalle, alarma.titulo, null, null, [1])
      }catch (err){}
    },

    open_dialog_change_user_password(user){
      this.$refs.dialog_change_user_password.open_dialog(user)
    },

    init_newrelic(){
      if (typeof newrelic == 'object') {
        newrelic.setCustomAttribute('Centro', `[${this.$store.state.centro.centro.id}] ${this.$store.state.centro.centro.nombre}`)
        newrelic.setCustomAttribute('User', `[${this.user.id}] ${this.user.nombre_completo} (${this.user.email})`)
      }
    },

    init_zopim(){
      $zopim(() => {
        $zopim.livechat.setName(this.user.nombre_completo);
        $zopim.livechat.setEmail(this.user.email);
        $zopim.livechat.setPhone(this.$store.state.centro.centro.telefono);
        $zopim.livechat.setLanguage(this.$store.state.locale.locale);
        $zopim.livechat.badge.setText(this.$t('¿Hablamos?'));
        $zopim.livechat.setGreetings({
          'online': this.$t('Ayuda'),
          'offline': this.$t('Déjanos un mensaje')
        });
        $zopim.livechat.window.setTitle(this.$t('Ayuda'));
        $zopim.livechat.concierge.setName(this.$t('Soporte'));
        $zopim.livechat.concierge.setTitle(this.$t('Te escuchamos'));
        $zopim.livechat.addTags(`Empresa: [${this.$store.state.centro.centro.empresa.id}] ${this.$store.state.centro.centro.empresa.nombre}`)
        $zopim.livechat.addTags(`Centro: [${this.$store.state.centro.centro.id}] ${this.$store.state.centro.centro.nombre}`)
        if (this.user.tipo_empleado === 'admin') {
          $zopim.livechat.addTags(`Rol: ${this.$t('Administrador')}`)
        } else {
          $zopim.livechat.addTags(`Rol: ${this.$t('Empleado')}`)
        }
        if (this.$store.state.centro.centro.is_premium) {
          $zopim.livechat.addTags("Premium");
        } else {
          $zopim.livechat.addTags("No premium");
        }
        if (this.$store.state.centro.centro.plan_contratado_obj) {
          $zopim.livechat.addTags(`Plan: ${this.$store.state.centro.centro.plan_contratado_obj.descripcion}`)
        }
      });
    },

    check_permission_browser_notifications(){
      if (typeof Notification != "undefined" && Notification.permission !== "granted") {
        Notification.requestPermission();
      }
    },

    show_browser_notification(body, title, audio, icon, users=[]){
      if(!users.includes(this.user.id)){
        return
      }
      if(!title) title = this.$t('Notificación')
      if(!audio) audio = `${this.aws_s3_bucket_url}assets/sounds/arpeggio.mp3`
      if(!icon) icon = `${this.aws_s3_bucket_url}assets/images/bell.webp`

      const sound = new Audio(audio);
      sound.load();
      sound.play();

      if (typeof Notification != "undefined" && Notification) {

        const notification = new Notification( title, {
          icon: icon,
          body: body
        });
        setTimeout( function() { notification.close() }, 15000);
      }
    }
  },
  mounted() {
    this.init_socket()
    // Si es sebymar ocultamos el zopim
    if(this.centro.distribuidor === CONSTANTS.DISTRIBUIDORES.SEBYMAR){
      $zopim(() => {
        $zopim.livechat.hideAll()
      })
    }else{
      $zopim(() => {
        $zopim.livechat.button.show()
      })
      this.init_zopim()
    }
    this.set_title_and_favicon()
    this.init_newrelic()
    this.check_permission_browser_notifications()
  },
  computed: {
    user: function () {
      return this.$store.getters['auth/user']
    },
    centro(){
      return this.$store.getters['centro/centro']
    },
    onmessage: function(){
      return this.$store.state.socket.message
    },
    dialog_tutorial () {
      return !this.$store.state.centro.centro.is_asistente_completado && !this.$store.state.auth.user.is_superuser
    }
  },
  watch: {
    onmessage: async function(payload){
      if(payload.type === 'open_alarma'){
        const id = payload.data.id
        const assigned_to = payload.data.assigned_to
        if(assigned_to.includes(this.user.id)){
          await this.open_dialog_alarma(id)
        }
      }
      // Cuando recibimos un whatsapp
      if(payload.type === 'whatsapp_message'){

        // Si está abierto el chat...
        if(this.dialog_chat){
          const ref_dialog_chat = this.$refs.dialog_chat
          // Y estamos en la misma conversación, no mostramos la notificación ni incrementamos el número de mensajes sin leer
          if(ref_dialog_chat && ref_dialog_chat.conversation_selected.id === payload.data.conversation){
            return
          }else{ // En caso de que estemos en otra conversación, no mostramos la notificación pero si incrementamos el número de mensajes sin leer
            this.$store.commit('centro/incremente_whatsapps_unreads')
            return
          }
        }

        this.$store.commit('centro/incremente_whatsapps_unreads')
        if (!this.centro.is_silenciar_notificaciones_whatsapp_business){
          this.show_browser_notification(this.$t('Nuevo WhatsApp recibido'), 'WhatsApp', null, null, [1])
        }
      }

      if(payload.type === 'show_message') {
        if (payload.data.type === 'success') {
          this.$snotify.success(
              payload.data.text,
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        } else if (payload.data.type === 'warning') {
          this.$snotify.warning(
              payload.data.text,
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        } else if (payload.data.type === 'error') {
          this.$snotify.error(
              payload.data.text,
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }

      if(payload.type === 'force_refresh_form_cita'){
          this.$store.commit('cita/clear_form_cita')
          this.$store.commit('cita/set_force_refresh', true)
      }
      if(payload.type === 'disponibilidad_cliente_en_espera'){
        const ids = payload.data.id
        const data = await this.$store.dispatch('lista_espera/get_lista_espera', {
          params: {
            id: ids.join(','),
            is_active: 1
          }
        })
        const clientes_en_espera = data['results']
        if (!!clientes_en_espera) {
          let list_clientes_en_espera_html = `<ul style="margin-left: 30px;">`
          clientes_en_espera.forEach((current_cliente_en_espera) => {
            list_clientes_en_espera_html += `<li>${current_cliente_en_espera.cliente_obj.text}</li>`
          })
          list_clientes_en_espera_html += `</ul>`
          this.$snotify.info(null, null, {
            html: `<div style="color: white">${this.$t("Los clientes en lista de espera que pueden ocupar la disponibilidad de la agenda son")}: ${list_clientes_en_espera_html}</div>`,
            timeout: 7000
          })
        }
      }
    }
  }
}
</script>
